import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchText',
})
export class SearchTextPipe implements PipeTransform {
  transform(
    items: any[],
    text: string,
    param: string,
    dotNotation?: string[]
  ): any {
    const mod = text.length % 3;
    const word = mod === 0 ? text : text.substr(0, text.length - mod);
    return text === '' || text.length < 3
      ? items
      : items.filter((item) => {
          if (!dotNotation) {
            return item[param].toLowerCase().includes(word.toLowerCase());
          } else {
            let newText = '';
            dotNotation.forEach((prop: string) => {
              newText =
                prop.split('.').reduce((a: any, b: any) => {
                  return a[b];
                }, item) +
                ' ' +
                newText;
            });
            return newText.toLowerCase().includes(word.toLowerCase());
          }
        });
  }
}
